import React, { useState } from "react";
import ReportsSvgComponent from "@assets/svg-components/sidebar/reports";
import { getColorStyle, getSingleColor } from "@common/color";
import {
  convertCurrentDate,
  convertCurrentDateWithTime,
} from "@common/date-helpers";
import {
  concatString,
  formatAmount,
  formatText,
  getFirstLetterOfEachString,
} from "@common/text-helpers";
import ProfileCircle from "@components/ProfileCircle";
import { getValue } from "@utils/lodash";
import { Tooltip } from "react-tooltip";
import { toast } from "react-toastify";
import {
  approveExpenseReport,
  rejectExpenseReport,
  sentbackExpenseReport,
} from "@services/expense-reports.service";
import ConfirmModal from "@common/popup/ConfirmModal";

function ReportsTable(props: any) {
 
  const [isOpen, setIsOpen] = useState(false);
  const [selectedReportId, setSelectedReportId] = useState("");
  const [submitStatus, setSubmitStatus] = useState("");
  const [rejectComments, setRejectComments] = useState("");
  const [statusLoading, setStatusLoading] = useState(false);

  // Modal handlers
  const handleModal = () => {
    setIsOpen(!isOpen);
    if (isOpen) {
      
      setSelectedReportId("");
      setSubmitStatus("");
      setRejectComments("");
    }
  };

  const openConfirmModal = (reportId: string, status: string) => {
    setSelectedReportId(reportId);
    setSubmitStatus(status);
    setRejectComments(""); 
    setIsOpen(true);
  };

  const handleSubmitStatus = async () => {
    if (!submitStatus || !selectedReportId) {
      toast.error("Something went wrong, Please try after sometime");
      return;
    }

    if (
      (submitStatus === "reject" || submitStatus === "sent-back") &&
      !rejectComments.trim()
    ) {
      toast.error("Please provide a reason for this action");
      return;
    }

    try {
      setStatusLoading(true);
      let resp;
      const payload: any = {
        comments: rejectComments.trim(),
      };
      const delegatedUserId = getValue(props, 'delegatedUserId', '');
      if (delegatedUserId && delegatedUserId !== 'self') {
        payload.delegated_user = Number(delegatedUserId);
      }

      if (submitStatus === "approve") {
        resp = await approveExpenseReport(selectedReportId, payload);
      } else if (submitStatus === "reject") {
        resp = await rejectExpenseReport(selectedReportId, payload);
      } else if (submitStatus === "sent-back") {
        resp = await sentbackExpenseReport(selectedReportId, payload);
      }

      if (resp) {
        toast.success(
          getValue(resp, `message`, "Action completed successfully")
        );
        if (props.onReportUpdate) {
          props.onReportUpdate(); 
        }
        handleModal(); 
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
      console.error("Error updating report status:", error);
    } finally {
      setStatusLoading(false);
    }
  };

  // Handle approve button click
  const handleApproveClick = (reportId: string) => {
    openConfirmModal(reportId, "approve");
  };

  return (
    <>
      <div>
        <div>
          <table className="datatable_table">
            <thead className="datatable_table_thead">
              <th className="datatable_table_th" style={{ width: "70px" }}>
                {/* <label
                  className="m-0 position-relative"
                  htmlFor="header-checkbox"
                >
                  <input
                    type="checkbox"
                    className="default-checkbox"
                    id="header-checkbox"
                    onChange={() =>
                      props.handleCheckAll(
                        getValue(props, `list.length`, 0) ===
                          getValue(props, `selectedIDs.length`, 0)
                          ? "All"
                          : "None"
                      )
                    }
                    checked={
                      getValue(props, `list.length`, 0) > 0 &&
                      getValue(props, `list.length`, 0) ===
                        getValue(props, `selectedIDs.length`, 0)
                    }
                  />
                  <div className="custom-checkbox">
                    <img
                      src="/images/uploaded-details/tick.svg"
                      className="img-fluid uploaded-tick"
                    />
                  </div>
                </label> */}
              </th>
              <th className="datatable_table_th">
                <h6 className="">Report ID</h6>
              </th>
              <th className="datatable_table_th">
                <h6 className="">Employee ID</h6>
              </th>
              <th className="datatable_table_th">
                <h6 className="">Report Name</h6>
              </th>
              {props.showDurationFromColumn && (
                <th className="datatable_table_th">
                  <h6 className="">Duration From</h6>
                </th>
              )}
              {props.showDurationToColumn && (
                <th className="datatable_table_th">
                  <h6 className="">Duration To</h6>
                </th>
              )}
              <th className="datatable_table_th">
                <h6 className="">Submitted by</h6>
              </th>
              <th className="datatable_table_th">
                <h6 className="">Total</h6>
              </th>
              <th className="datatable_table_th">
                <h6 className="">Approval Status</h6>
              </th>
              {/* Conditionally render Action column header */}
              {props.showActionColumn && (
                <th className="datatable_table_th">
                  <h6 className="">Action</h6>
                </th>
              )}
            </thead>
            <tbody className="datatable_table_tbody">
              {getValue(props, `list`, []).map((item: any, index: number) => {
                return (
                  <tr key={index} className="datatable_table_tr">
                    <td className="datatable_table_td" style={{ width: "70px" }}>
                      {/* <label
                        className="m-0 position-relative"
                        htmlFor={`header-checkbox-${index}`}
                      >
                        <input
                          type="checkbox"
                          className="default-checkbox"
                          id={`header-checkbox-${index}`}
                          onChange={() =>
                            props.handleCheckUsers(getValue(item, `id`, ""))
                          }
                          checked={getValue(props, `selectedIDs`, []).includes(
                            getValue(item, `id`, "")
                          )}
                        />
                        <div className="custom-checkbox">
                          <img
                            src="/images/uploaded-details/tick.svg"
                            className="img-fluid uploaded-tick"
                          />
                        </div>
                      </label> */}
                      <ReportsSvgComponent
                        color={getSingleColor(
                          getValue(item, `approval_status`, "")
                        )}
                        size={24}
                      />
                    </td>
                    <td
                      className="datatable_table_td align-items-center"
                      onClick={() =>
                        props.handleNavigate(getValue(item, `id`, ""))
                      }
                    >
                      <div className="d-flex">
                        <div>
                          <h6 className="header_text color_primary">
                            {getValue(item, `report_id`, "")}
                          </h6>
                        </div>
                      </div>
                    </td>
                    <td
                      onClick={() =>
                        props.handleNavigate(getValue(item, `id`, ""))
                      }
                      className={`datatable_table_td`}
                    >
                      <h6 className="">
                        {getValue(item, `created_by.employee_id`, "")}
                      </h6>
                    </td>
                    <td
                      className="datatable_table_td"
                      onClick={() =>
                        props.handleNavigate(getValue(item, `id`, ""))
                      }
                    >
                      <h6 className="">
                        {concatString(getValue(item, `report_name`, ""), 30)}
                      </h6>
                    </td>
                    {props.showDurationFromColumn && (
                      <td
                        className="datatable_table_td"
                        onClick={() =>
                          props.handleNavigate(getValue(item, `id`, ""))
                        }
                      >
                        <h6 className="">
                          {convertCurrentDate(getValue(item, `duration_from`, ""))}
                        </h6>
                      </td>
                    )}
                    {props.showDurationToColumn && (
                      <td
                        className="datatable_table_td"
                        onClick={() =>
                          props.handleNavigate(getValue(item, `id`, ""))
                        }
                      >
                        <h6 className="">
                          {convertCurrentDate(getValue(item, `duration_to`, ""))}
                        </h6>
                      </td>
                    )}
                    <td
                      className="datatable_table_td"
                      onClick={() =>
                        props.handleNavigate(getValue(item, `id`, ""))
                      }
                    >
                      {getValue(item, `created_by.email`, "") ? (
                        <div className="d-flex align-items-center">
                          <ProfileCircle
                            name="created_by"
                            item={item}
                            value={getValue(item, `created_by.first_name`, "")}
                          />
                          <div>
                            <h6>
                              {" "}
                              {getValue(item, `created_by.first_name`, "")}{" "}
                              {getValue(item, `created_by.middle_name`, "")}{" "}
                              {getValue(item, `created_by.last_name`, "")}
                            </h6>
                            <p>{getValue(item, `created_by.email`, "")}</p>
                          </div>
                        </div>
                      ) : (
                        <p className="text-center ms-5">-</p>
                      )}
                    </td>
                    <td
                      className="datatable_table_td"
                      onClick={() =>
                        props.handleNavigate(getValue(item, `id`, ""))
                      }
                    >
                      <h6 className="">
                        {getValue(item, `currency_symbol`, "")}{" "}
                        {formatAmount(getValue(item, `total`, ""))}
                      </h6>
                    </td>
                    <td
                      className="datatable_table_td"
                      onClick={() =>
                        props.handleNavigate(getValue(item, `id`, ""))
                      }
                    >
                      <h6
                        className=""
                        style={getColorStyle(
                          getValue(item, `approval_status`, "")
                        )}
                      >
                        {formatText(getValue(item, `approval_status`, ""))}
                      </h6>
                    </td>
                    {/* Conditionally render Action column cell */}
                    {props.showActionColumn && (
                      <td className="datatable_table_td">
                        <button
                        
                          style={{
                            background: "white",
                            border: "1px solid #dadce0",
                            color: "#28b463",
                            paddingTop: "5px",
                            paddingBottom: "5px",
                            borderRadius: "5px",
                            minWidth: "70px",
                            maxWidth: "120px",
                            display: "flex",
                            justifyContent: "center",
                            fontSize: "12px",
                          }}
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent row click navigation
                            handleApproveClick(getValue(item, "id", ""));
                          }}
                          disabled={statusLoading}
                        >
                          {statusLoading ? "Processing..." : "Approve"}
                        </button>
                      </td>
                    )}
                    {/* <td className="datatable_table_td">
                    <div className="more-dropdown">
                      <UncontrolledDropdown>
                        <DropdownToggle>
                          <div className="switch_header__dropdown m-0">
                            <div className="dropdown-content d-flex cursor-pointer">
                              <img
                                src="/images/more.svg"
                                width="24px"
                                height="24px"
                                className="img-fluid"
                              />
                            </div>
                          </div>
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem
                            onClick={() =>
                              props.handleNavigate(getValue(item, `id`, ""))
                            }
                          >
                            <div className={`more-dropdown-item `}>
                              <p>Edit</p>
                            </div>
                          </DropdownItem>
                          <DropdownItem
                            onClick={() =>
                              props.sendInviteUser(getValue(item, `id`, ""))
                            }
                          >
                            <div className={`more-dropdown-item `}>
                              <p>View</p>
                            </div>
                          </DropdownItem>
                          <DropdownItem
                            onClick={() =>
                              props.handleDeleteFun(
                                getValue(item, `id`, ""),
                                getValue(item, `title`, "")
                              )
                            }
                          >
                            <div className={`more-dropdown-item `}>
                              <p>Delete</p>
                            </div>
                          </DropdownItem>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </div>
                  </td> */}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <Tooltip id="my-tooltip" />
      </div>

      <ConfirmModal
        isOpen={isOpen}
        handleModal={handleModal}
        handleSubmit={handleSubmitStatus}
        submitLoading={statusLoading}
        submitStatus={submitStatus}
        comment={rejectComments}
        setComment={setRejectComments}
      />
    </>
  );
}

export default ReportsTable;
